import React, { useState } from 'react';
import axios from 'axios';
import '../styles/Login.css';

// Configure axios for development/production
// In development: http://localhost:5001
// In production: empty string (uses relative paths with current domain)
const API_BASE_URL = process.env.NODE_ENV === 'production' 
  ? '' 
  : process.env.REACT_APP_API_URL || 'http://localhost:5001';

function Login({ onLogin }) {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await axios.post(`${API_BASE_URL}/auth/login`, {
        username,
        password
      });
      localStorage.setItem('token', response.data.token);
      localStorage.setItem('userEmail', response.data.username);
      onLogin(response.data.username);
    } catch (err) {
      setError('Invalid credentials');
    }
  };

  return (
    <div className="login-wrapper">
      <div className="login-brand">
        <h1>Find QA Answers</h1>
        <p>Ace your Test Automation interviews with our AI-powered Q&A platform</p>
      </div>
      <div className="login-container">
        <div className="login-card">
          <h2>Login</h2>
          <div className="subtitle">Find QA Answers @OMR Branch</div>
          {error && <div className="error">{error}</div>}
          <form onSubmit={handleSubmit} className="login-form">
            <input
              type="text"
              placeholder="Email or Username"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              required
            />
            <input
              type="password"
              placeholder="Password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
            <button type="submit">Login</button>
          </form>
        </div>
      </div>
    </div>
  );
}

export default Login;
